import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ProductImageModal from './ProductImageModal';
import ProductImageCarousel from './ProductImageCarousel';

import { getOriginal } from './mapImageToSrc';

class ProductImageCarouselWrapper extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            currentIndex: 0,
            currentImage: props.images.large[0] && getOriginal(props.images.large[0]) || null
        };
        this.onImageIndexChanged = this.onImageIndexChanged.bind(this);
        this.onShowBigger = this.onShowBigger.bind(this);
        this.onRequestClose = this.onRequestClose.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.images.code !== this.props.images.code) {
            this.onImageIndexChanged(0);
        }
    }

    onShowBigger() {
        this.setState({ isOpen: true });
    }

    onImageIndexChanged(index) {
        if (!Number.isInteger(index)) {
            console.error(`expected a number but got ${index}`);
        } else {
            if (index < this.props.images.large.length && index > -1) {
                this.setState({ currentIndex: index });
                this.setState({ currentImage: getOriginal(this.props.images.large[index]) });
            } else {
                this.setState({ currentImage: "" });
                console.error(`index out of bounds: ${index}. Images length is ${this.props.images.large.length}`);
            }
        }
    }

    onRequestClose() {
        this.setState({ isOpen: false });
    }

    render() {
        const { images, fallbackTitle } = this.props;
        const { isOpen, currentIndex, currentImage, currentImageTitle } = this.state;
        return (
            <Fragment>
                <ProductImageCarousel
                    images={images}
                    onImageIndexChanged={this.onImageIndexChanged}
                    onShowBigger={this.onShowBigger}
                    currentIndex={currentIndex}
                />
                <ProductImageModal
                    currentImageSrc={currentImage}
                    isOpen={isOpen}
                    currentImageTitle={currentImageTitle || fallbackTitle}
                    onRequestClose={this.onRequestClose}
                />
            </Fragment>
        );
    }
}

ProductImageCarouselWrapper.propTypes = {
    fallbackTitle: PropTypes.string,
    images: PropTypes.object
};

export default ProductImageCarouselWrapper;